export default "__VITE_ASSET__OVIhGclx__"